import React from "react";
import OfferTemplatePage from "./../pages/OfferTemplatePage";

const OfferLongPage = () => {
  return <OfferTemplatePage type="long" />;
};

export default OfferLongPage;
